import { Theme } from '@material-ui/core';
import { grisMoyen, redMain } from '../../theme';

const styles = (theme: Theme) =>
  ({
    homePage: {
      maxWidth: 1000,
      margin: 'auto',
    },
    container: {
      '& > h3': {
        marginBottom: 24,
      },
    },
    asterisk: {
      color: grisMoyen,
    },
    title: {
      '& > div': {
        marginBottom: 24,
      },
      '& h1': {
        marginBottom: 0,
        marginTop: 38,
        fontWeight: '200',
      },
    },
    illuHome: {
      '& > svg': {
        position: 'fixed',
        bottom: 0,
        right: 0,
        zIndex: 100,
        width: 400,
      },
    },
    containerAvantages: {
      margin: '24px 0 0 0',
    },
    containerCards: {
      display: 'flex',
      marginTop: 24,
      gap: 24,
      flexWrap: 'wrap',
    },
    containerCard: {
      boxShadow: 'none',
      border: '1px solid #DADADA',
      width: '196px',
      borderRadius: 12,
      marginBottom: 16,
    },
    cardImg: {
      height: 140,
    },
    cardTitle: {
      textAlign: 'center',
      fontSize: 16,
      fontFamily: 'Poppins',
      color: redMain,
      padding: '16px 24px',
    },
    msgPremiereVisite: {
      width: '100%',
      display: 'flex',
      alignItems: 'center',
      '& > svg': {
        marginRight: 24,
        marginLeft: 8,
        '& > g': {
          fill: redMain,
        },
      },
    },
    '@media all and (max-width: 1200px)': {
      illuHome: {
        width: '85vw',
        marginLeft: 0,
      },
    },
    '@media all and (max-width: 962px)': {
      title: {
        '& > button': {
          marginBottom: 18,
        },
      },
    },
    '@media all and (max-width: 886px)': {
      container: {
        flexDirection: 'column-reverse',
        alignItems: 'flex-start',
      },
      homePage: {
        '& h1': {
          fontSize: 23,
          marginTop: 18,
        },
      },
    },
  } as any);

export default styles;
